import script from "./AdminLayoutMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLayoutMenu.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLayoutMenu.vue?vue&type=style&index=0&id=75769960&lang=scss"

const __exports__ = script;

export default __exports__